import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Alert, Form, Checkbox, Input, Button, Select, Row, Col, Divider, Tooltip, Icon } from 'antd';

import { connect } from 'react-redux';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { createStructuredSelector } from 'reselect';
import reducer from './reducer';
import saga from './saga';
import { saveProposal, selectContractualCategoryType } from './actions';
import { default as Loader } from "../Loader";
import { makeSelectLoading, makeSelectContractualCategoryTypeSelected, selectErrors, selectHasErrors } from './selectors';
import { makeSelectFeesSelector } from '../CustomizeOffer/selectors';

import * as Validator from '../CarQuote/validator';

import messages from './messages';
import {
  CONTRACTUAL_CATEGORIES,
  CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
  CONTRACTUAL_CATEGORIES_TYPE_PRIVATE,
  CONTRACTUAL_CATEGORIES_TYPES_TAG_MAP,
} from '../CarQuote/constants';
import 'antComponentsStyle';

class CustomerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputChanged: false,
      consent: false,
      fiscalCodeHasError: false,
      errors: {},
    };
  }

  get isBusinessEmployee() {
    const employee_category = this.props.customer.employee_category;

    if (employee_category !== undefined) {
      const selectedContractualCategory = CONTRACTUAL_CATEGORIES.filter(category => category.value === employee_category);
      return selectedContractualCategory[0] && selectedContractualCategory[0].type === CONTRACTUAL_CATEGORIES_TYPE_BUSINESS;
    }

    return false;
  }

  isValid() {
    let valid = true;
    const errors = {};

    if (this.quotationExists) {
      return valid;
    }

    if (!this.props.customer.first_name || this.props.customer.first_name.length < 1) {
      valid = false;
      errors.first_name = true;
    }

    if (!this.props.customer.last_name || this.props.customer.last_name.length < 1) {
      valid = false;
      errors.last_name = true;
    }

    if (!Validator.validateEmail(this.props.customer.email)) {
      valid = false;
      errors.email = true;
    }

    if (
      this.props.customer.phone &&
      !Validator.validatePhone(this.props.customer.phone)
    ) {
      valid = false;
      errors.phone = true;
    }

    if (this.props.customer.address && this.props.customer.address.length < 1) {
      valid = false;
      errors.address = true;
    }

    if (this.props.customer.city && this.props.customer.city.length < 1) {
      valid = false;
      errors.city = true;
    }

    if (
      this.props.customer.zip_code &&
      !Validator.validatePostalCode(this.props.customer.zip_code)
    ) {
      valid = false;
      errors.zip_code = true;
    }

    if (
      !this.props.customer.fiscal_code ||
      this.props.customer.fiscal_code.length < 1
    ) {
      valid = false;
      errors.fiscal_code = true;
    }

    if (
      this.isBusinessEmployee &&
      !Validator.validateVatNumber(this.props.customer.vat_number)
    ) {
      valid = false;
      errors.vat_number = true;
    }

    if (
      this.isBusinessEmployee &&
      (!this.props.customer.business_name ||
        this.props.customer.business_name.length < 1)
    ) {
      valid = false;
      errors.business_name = true;
    }

    if (
      this.isBusinessEmployee &&
      !Validator.validateEmail(this.props.customer.pec)
    ) {
      valid = false;
      errors.pec = true;
    }

    this.setState({ errors });
    return valid;
  }

  get canSubmit() {
    if (this.quotationExists) {
      return true;
    }

    const {
      first_name,
      last_name,
      email,
      address,
      zip_code,
      city,
      phone,
      fiscal_code,
      employee_category,
      vat_number,
      business_name,
      pec,
      sdi_code,
    } = this.props.customer;

    const { consent, fiscalCodeHasError, errors } = this.state;

    const contractualCategories = this.getContractualCategoriesByOfferTag();

    return (
      !fiscalCodeHasError &&
      Object.values(errors).length === 0 &&
      first_name &&
      first_name.trim() !== '' &&
      last_name &&
      last_name.trim() !== '' &&
      email &&
      email.trim() !== '' &&
      address &&
      address.trim() !== '' &&
      zip_code &&
      zip_code.trim() !== '' &&
      city &&
      city.trim() !== '' &&
      phone &&
      phone.trim() !== '' &&
      fiscal_code &&
      fiscal_code.trim() !== '' &&
      consent === true &&
      employee_category &&
      employee_category.trim() !== '' &&
      contractualCategories.some(contractualCategory => contractualCategory.value === employee_category) &&
      (!this.isBusinessEmployee ||
        (vat_number &&
          vat_number.trim() !== '' &&
          business_name &&
          business_name.trim() !== '' &&
          pec &&
          pec.trim() !== '' &&
          sdi_code &&
          sdi_code.trim() !== ''))
    );
  }

  handleSubmit = e => {
    e.preventDefault();

    if (this.isValid()) {
      const {
        services,
        accessories,
        colors,
        newMonthlyRate,
        onNext,
        fees,
        prescoringData,
      } = this.props;
      const offer = this.offerData;

      if (this.quotationExists) {
        onNext(2);
      } else {
        const {
          first_name,
          last_name,
          email,
          fiscal_code,
          employee_category,
          vat_number,
          business_name,
          pec,
          sdi_code,
          phone,
          address,
          zip_code,
          city,
          notes,
        } = this.props.customer;

        const { consent } = this.state;

        const sustainability = {
          "step": prescoringData.inputData.step || prescoringData.response.currentStep || null,
          "logic": prescoringData.logic || [],
          "answers": prescoringData.inputData.answers || {},
          "response": {
            ...prescoringData.response,
            "chance": offer.sustainabilityIndex >= 0 ? offer.sustainabilityIndex : prescoringData.response.chance,
            "description": offer.sustainabilityMessage && offer.sustainabilityMessage != '' ? offer.sustainabilityMessage : prescoringData.response.description,
          },
          "contractualCategory": prescoringData.inputData.contractualCategory
      };

        this.props.saveProposal({
          accessories: accessories.length ? accessories : [],
          business_name,
          pec,
          sdi_code,
          additionalServices: services,
          colors: colors.length ? colors : [],
          consent,
          email,
          employee_category,
          first_name,
          fiscal_code,
          last_name,
          phone,
          address,
          zip_code,
          city,
          notes,
          newMonthlyRate,
          offer,
          vat_number,
          fees,
          sustainability
        });
      }
    }
  };

  onFiscalCodeChange = e => {
    const value = e.target.value;
    const fiscalCode = value.trim().toUpperCase();

    if (fiscalCode.length === 16) {
      if (Validator.validateFiscalCode(fiscalCode)) {
        this.setState({
          fiscalCodeHasError: false
        });

        this.props.searchCustomerByFiscal(fiscalCode, this.props.customer.employee_category);
      } else {
        this.setState({ fiscalCodeHasError: true });
      }
    }
  };

  onVatNumberChange = e => {
    const value = e.target.value;
    const vatNumber = value.trim().toUpperCase();

    if (vatNumber.length === 11) {
      if (Validator.validateVatNumber(vatNumber)) {
        this.setState({
          vatNumberHasError: false
        });

        this.props.searchCustomerByVat(vatNumber, this.props.customer.employee_category);
      } else {
        this.setState({ vatNumberHasError: true });
      }
    }
  };

  onInputChange = e => {
    this.props.onInputChange(e);

    this.setState({
      errors: {}
    });
  };

  onConsentChange = e => {
    this.setState({ consent: e.target.checked });
  };

  componentDidMount() {
    let { prescoringData: { inputData } } = this.props;
    inputData = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};

    if (inputData && inputData.contractualCategory) {
      this.onEmployeeCategoryChange(inputData.contractualCategory);
    }
  }

  onEmployeeCategoryChange = value => {
    if (this.offerContractualCategoryType === CONTRACTUAL_CATEGORIES_TYPE_PRIVATE ||
        this.props.contractualCategoryTypeSelected === CONTRACTUAL_CATEGORIES_TYPE_PRIVATE) {
      this.props.searchCustomerByFiscal(this.props.customer.fiscal_code, value, this.props.customer)
    } else {
      this.props.searchCustomerByVat(this.props.customer.vat_number, value, this.props.customer)
    }
  }

  onContractualCategoryTypeChange = value => {
    if (!this.props.contractualCategoryTypeSelected ||
        (
          !this.props.customerFound &&
          this.hasCustomer &&
          confirm('I dati anagrafici inseriti verranno cancellati. Sei sicuro di voler continuare?')
        )
      ) {
      this.props.selectContractualCategoryType(value)
      this.props.resetCustomer()
    } else if ((this.props.customerFound && this.hasCustomer) || !this.hasCustomer) {
      this.props.selectContractualCategoryType(value)
      this.props.resetCustomer()
    }
  }

  get quotationExists() {
    return this.props.proposal && this.props.proposal.quotation && this.props.proposal.quotation.data && this.props.proposal.quotation.data.code !== undefined;
  }

  get proposalExists() {
    return this.props.proposal && this.props.proposal.id && this.props.proposal.id > 0;
  }

  get hasCustomer() {
    return this.props.customer.hasOwnProperty('fiscal_code') || this.props.customer.hasOwnProperty('vat_number');
  }

  get offerData() {
    return this.props.proposal.offer && this.props.proposal.offer.data ?
            this.props.proposal.offer.data :
            this.props.proposal.quotation && this.props.proposal.quotation.data.offer.data ?
            this.props.proposal.quotation.data.offer.data :
            null;
  }

  get offerCustomUrl() {
    const offerData = this.offerData;

    if (offerData) {
      return [
        '/offers/',
        offerData.code,
        '?duration=',
        offerData.duration,
        '&deposit=',
        offerData.deposit,
        '&distance=',
        offerData.distance,
        '&accessories=',
        this.props.selectedAccessories.join(),
        '&colors=',
        this.props.selectedColors.join(),
      ].join('');
    }
  }

  getContractualCategoriesByOfferTag = () => {
    let contractualCategories = CONTRACTUAL_CATEGORIES;
    let mappedType = this.offerContractualCategoryType || this.props.contractualCategoryTypeSelected;

    if (!mappedType) {
      mappedType = this.isBusinessEmployee ? CONTRACTUAL_CATEGORIES_TYPE_BUSINESS : CONTRACTUAL_CATEGORIES_TYPE_PRIVATE;
    }

    if (mappedType) {
      contractualCategories = CONTRACTUAL_CATEGORIES
                                .filter(contractualCategory => contractualCategory.type === mappedType)
    }

    return contractualCategories;
  }

  get offerContractualCategoryType() {
    let tag = this.props.offer.tag || (this.proposalExists && this.props.proposal.offer.data.leftLabel);
    let secondaryTag = this.props.offer.secondaryTag || (this.proposalExists && this.props.proposal.offer.data.rightLabel);

    let { prescoringData: { inputData } } = this.props;
    inputData = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};

    if (inputData.contractualCategory) {
      return CONTRACTUAL_CATEGORIES
        .find(contractual_category => contractual_category.value === inputData.contractualCategory)
        .type;
    }

    // prendo i tag da local storage
    tag = (!tag || tag === '') && this.props.proposal.quotation && this.props.proposal.quotation.data.offer ? this.props.proposal.quotation.data.offer.data.tag : tag;
    secondaryTag = (!secondaryTag || secondaryTag === '') && this.props.proposal.quotation && this.props.proposal.quotation.data.offer ? this.props.proposal.quotation.data.offer.data.secondaryTag : secondaryTag;

    if (tag || secondaryTag) {
      return CONTRACTUAL_CATEGORIES_TYPES_TAG_MAP[tag] || CONTRACTUAL_CATEGORIES_TYPES_TAG_MAP[secondaryTag]
    }

    return null
  }

  render() {
    const contractualCategories = this.getContractualCategoriesByOfferTag();
    const categories = [
      {
        description: 'Seleziona...',
        value: '',
        type: 'PRIVATE',
        secondaryType: 'PRIVATE',
      },
      ...contractualCategories,
    ];

    const disabledSubmit = !this.canSubmit;
    const { errors } = this.state;
    let { loading, customer, contractualCategoryTypeSelected, proposalErrors, hasErrors, prescoringData: { inputData } } = this.props;
    inputData = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};

    if (!contractualCategoryTypeSelected && this.proposalExists) {
      contractualCategoryTypeSelected = this.isBusinessEmployee ? CONTRACTUAL_CATEGORIES_TYPE_BUSINESS : CONTRACTUAL_CATEGORIES_TYPE_PRIVATE;
    }

    let contractualCategoriesSelectIsDisabled = false;
    let contractualCategorySelected =
      customer.category
        ? customer.category.code
        : customer.employee_category ? customer.employee_category : null;

    if (contractualCategorySelected && !contractualCategories.some(contractualCategory => contractualCategory.value === contractualCategorySelected)) {
      contractualCategorySelected = null;
    }

    if (inputData.contractualCategory) {
      contractualCategoriesSelectIsDisabled = true;
    }

    const zip_code = customer.zip_code;
    const address = customer.address || '';

    let criticalError = false;

    if (hasErrors) {
      if (proposalErrors === 'Invalid zip code') {
        proposalErrors = 'Siamo spiacenti, ma il CAP inserito non sembra essere valido.';
      } else if (proposalErrors === 'Contractual category not valid') {
        proposalErrors = 'Attenzione, la categoria contrattuale non è valida.';
      } else if (proposalErrors === 'Customer type not compatible with offer') {
        criticalError = true;
        proposalErrors =
          <>Spiacenti, si è verificato un errore durante la richiesta. <a href={this.offerCustomUrl}>Clicca qui per tornare all'offerta selezionata.</a></>
      } else {
        proposalErrors = <FormattedMessage {...messages.alertError} />;
      }
    }

    return (
      <Form layout="vertical" className="position-relative">
        {loading &&
          <Loader loading={true} />
        }
        {hasErrors && (
          <Alert
            type="error"
            isOpen={true}
            closable
            className="mb-4"
            message={proposalErrors}
          />
        )}
        {!this.offerContractualCategoryType && !this.proposalExists &&
          <Row gutter={16} className="mb-4">
            <Col md={12} className="text-right">
              <Button
                size="large"
                type={contractualCategoryTypeSelected === CONTRACTUAL_CATEGORIES_TYPE_BUSINESS ? 'primary' : 'default'}
                onClick={() => this.onContractualCategoryTypeChange(CONTRACTUAL_CATEGORIES_TYPE_BUSINESS)}
              >P.IVA</Button>
            </Col>
            <Col md={12}>
              <Button
                size="large"
                type={contractualCategoryTypeSelected === CONTRACTUAL_CATEGORIES_TYPE_PRIVATE ? 'primary' : 'default'}
                onClick={() => this.onContractualCategoryTypeChange(CONTRACTUAL_CATEGORIES_TYPE_PRIVATE)}
              >Privati</Button>
            </Col>
          </Row>
        }
        {this.hasCustomer ? (
          <>
          <Row gutter={16}>
            <Col md={12}>
            <>
              {
                {
                  [CONTRACTUAL_CATEGORIES_TYPE_BUSINESS]:
                  <Form.Item
                    required
                    label={<FormattedMessage {...messages.vatNumber} />}
                    validateStatus={errors.vat_number === true ? 'error' : null}
                  >
                    <Input
                      name="vat_number"
                      id="vat_number"
                      size="large"
                      placeholder="Partita IVA"
                      defaultValue={customer.vat_number}
                      onChange={this.onVatNumberChange}
                      disabled={criticalError || this.quotationExists}
                    />
                  </Form.Item>,
                  [CONTRACTUAL_CATEGORIES_TYPE_PRIVATE]:
                  <FiscalCodeInput
                    fiscalCodeHasError={this.state.fiscalCodeHasError}
                    fiscal_code={customer.fiscal_code}
                    onFiscalCodeChange={this.onFiscalCodeChange}
                    disabledFields={criticalError || this.quotationExists}
                    label={<>
                        <FormattedMessage {...messages.fiscalCodePersonal} />
                        &nbsp;
                        <Tooltip title={<FormattedMessage {...messages.fiscalCodeTooltip} />}>
                          <Icon type="question-circle-o" />
                        </Tooltip>
                      </>}
                  />
                }[contractualCategoryTypeSelected || this.offerContractualCategoryType]
              }
            </>
            </Col>
            <Col md={12}>
              <Form.Item
                required
                label={<FormattedMessage {...messages.contractualsCategories} />}
              >
                <Select
                  name="employee_category"
                  size="large"
                  value={contractualCategorySelected}
                  onChange={this.onEmployeeCategoryChange}
                  disabled={criticalError || this.proposalExists || contractualCategoriesSelectIsDisabled}
                >
                  {categories.map(item => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.description}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            </Row>
            {((this.offerContractualCategoryType || contractualCategoryTypeSelected) === CONTRACTUAL_CATEGORIES_TYPE_BUSINESS) && (
              <Row gutter={16}>
                <Col md={12}>
                <FiscalCodeInput
                  fiscalCodeHasError={this.state.fiscalCodeHasError}
                  fiscal_code={customer.fiscal_code}
                  onFiscalCodeChange={this.onInputChange}
                  disabledFields={criticalError || this.quotationExists}
                  label={<>
                    <FormattedMessage {...messages.fiscalCodeBusiness} />
                    &nbsp;
                    <Tooltip title={<FormattedMessage {...messages.fiscalCodeBusinessTooltip} />}>
                      <Icon type="question-circle-o" />
                    </Tooltip>
                  </>}
                />
                </Col>
                <Col md={12}>
                  <Form.Item
                    required
                    label={<FormattedMessage {...messages.businessName} />}
                    validateStatus={errors.business_name === true ? 'error' : null}
                  >
                    <Input
                      name="business_name"
                      id="business_name"
                      size="large"
                      placeholder="Ragione sociale"
                      value={customer.business_name}
                      onChange={this.onInputChange}
                      disabled={criticalError || this.quotationExists}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row gutter={16}>
              <Col md={12}>
                <Form.Item
                  required
                  label={<FormattedMessage {...messages.firstName} />}
                  validateStatus={errors.first_name === true ? 'error' : null}
                >
                  <Input
                    name="first_name"
                    id="first_name"
                    size="large"
                    placeholder="Nome cliente"
                    value={customer.first_name}
                    onChange={this.onInputChange}
                    autoComplete="given-name"
                    disabled={criticalError || this.quotationExists}
                  />
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item
                  required
                  label={<FormattedMessage {...messages.lastName} />}
                  validateStatus={errors.last_name === true ? 'error' : null}
                >
                  <Input
                    name="last_name"
                    id="last_name"
                    size="large"
                    placeholder="Cognome cliente"
                    value={customer.last_name}
                    onChange={this.onInputChange}
                    disabled={criticalError || this.quotationExists}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={12}>
                <Form.Item
                  required
                  label="Email"
                  validateStatus={errors.email === true ? 'error' : null}
                >
                  <Input
                    type="email"
                    name="email"
                    id="email"
                    size="large"
                    placeholder="Indirizzo email"
                    value={customer.email}
                    onChange={this.onInputChange}
                    disabled={criticalError || this.quotationExists}
                  />
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item
                  required
                  label="Telefono"
                  validateStatus={errors.phone === true ? 'error' : null}>
                  <Input
                    name="phone"
                    id="phone"
                    size="large"
                    placeholder="Numero di telefono"
                    value={customer.phone}
                    onChange={this.onInputChange}
                    disabled={criticalError || this.quotationExists}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={12}>
                <Form.Item
                  required
                  label="Indirizzo"
                  validateStatus={errors.address === true ? 'error' : null}>
                  <Input
                    name="address"
                    id="address"
                    size="large"
                    placeholder="Indirizzo"
                    value={address}
                    onChange={this.onInputChange}
                    disabled={criticalError || this.quotationExists}
                  />
                </Form.Item>
              </Col>
              <Col md={3}>
                <Form.Item
                  required
                  label="Cap"
                  validateStatus={errors.zip_code === true ? 'error' : null}>
                  <Input
                    name="zip_code"
                    id="zip_code"
                    size="large"
                    placeholder="Cap"
                    maxLength={5}
                    value={zip_code}
                    onChange={this.onInputChange}
                    disabled={criticalError || this.quotationExists}
                  />
                </Form.Item>
              </Col>
              <Col md={9}>
                <Form.Item
                  required
                  label="Comune"
                  validateStatus={errors.city === true ? 'error' : null}>
                  <Input
                    name="city"
                    id="city"
                    size="large"
                    placeholder="Comune"
                    value={customer.city}
                    onChange={this.onInputChange}
                    disabled={criticalError || this.quotationExists}
                  />
                </Form.Item>
              </Col>
            </Row>
            {
              {
                [CONTRACTUAL_CATEGORIES_TYPE_BUSINESS]:
                <Row gutter={16}>
                  <Col md={12}>
                    <Form.Item
                      required
                      label={<FormattedMessage {...messages.pec} />}
                      validateStatus={errors.pec === true ? 'error' : null}
                    >
                      <Input
                        type="email"
                        name="pec"
                        id="pec"
                        size="large"
                        placeholder={messages.pec.defaultMessage}
                        value={customer.pec}
                        onChange={this.onInputChange}
                        disabled={criticalError || this.quotationExists}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12}>
                    <Form.Item
                      required
                      label={<FormattedMessage {...messages.sdiCode} />}
                      validateStatus={errors.sdi_code === true ? 'error' : null}
                    >
                      <Input
                        name="sdi_code"
                        id="sdi_code"
                        size="large"
                        placeholder={messages.sdiCode.defaultMessage}
                        defaultValue={customer.sdi_code}
                        onChange={this.onInputChange}
                        disabled={criticalError || this.quotationExists}
                      />
                    </Form.Item>
                  </Col>
                </Row>,
                [CONTRACTUAL_CATEGORIES_TYPE_PRIVATE]:
                <></>
              }[contractualCategoryTypeSelected || this.offerContractualCategoryType]
            }
            <Row>
              <Col md={24}>
                <Form.Item label="Note preventivo">
                  <Input.TextArea
                    name="notes"
                    id="notes"
                    size="large"
                    placeholder="Colore desiderato, optional richiesti, ..."
                    value={customer.notes}
                    onChange={this.onInputChange}
                    disabled={criticalError || this.quotationExists}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={24}>
                <Form.Item required>
                  <Checkbox
                    name="consenso"
                    onChange={this.onConsentChange}
                    defaultChecked={this.quotationExists}
                    disabled={criticalError || this.quotationExists}
                    checked={this.state.consent}
                  >
                    <FormattedMessage {...messages.confirm_terms}>
                      {txt => (
                        <span className="ant-form-item-required">{txt}</span>
                      )}
                    </FormattedMessage>
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </>
        ) :
        <>
          {
            {
              [CONTRACTUAL_CATEGORIES_TYPE_BUSINESS]:
              <Row gutter={16}>
                <Col md={12}>
                  <Form.Item
                      required
                      label={<FormattedMessage {...messages.vatNumber} />}
                      validateStatus={errors.vat_number === true ? 'error' : null}
                    >
                      <Input
                        name="vat_number"
                        id="vat_number"
                        size="large"
                        placeholder="Partita IVA"
                        defaultValue={customer.vat_number}
                        onChange={this.onVatNumberChange}
                        disabled={criticalError || this.quotationExists}
                      />
                    </Form.Item>
                </Col>
              </Row>,
              [CONTRACTUAL_CATEGORIES_TYPE_PRIVATE]:
              <Row gutter={16}>
                <Col md={12}>
                  <FiscalCodeInput
                    fiscalCodeHasError={this.state.fiscalCodeHasError}
                    fiscal_code={this.state.fiscal_code}
                    disabledFields={criticalError}
                    onFiscalCodeChange={this.onFiscalCodeChange}
                    label={<>
                        <FormattedMessage {...messages.fiscalCodePersonal} />
                        &nbsp;
                        <Tooltip title={<FormattedMessage {...messages.fiscalCodeTooltip} />}>
                          <Icon type="question-circle-o" />
                        </Tooltip>
                      </>}
                  />
                </Col>
              </Row>
            }[contractualCategoryTypeSelected || this.offerContractualCategoryType]
          }
        </>
        }

          <Divider />
          <Row gutter={16}>
            <Col md={12}>
            <Button
                size="large"
                icon="arrow-left"
                type="link"
                href={this.offerCustomUrl}
              >
                <FormattedMessage {...messages.backToOffer} />
              </Button>
            </Col>
            <Col md={12} className="text-right">
                <Button
                  size="large"
                  className="btn-primary"
                  type="primary"
                  onClick={this.handleSubmit}
                  disabled={criticalError || disabledSubmit || loading}
                >
                  <FormattedMessage {...messages.ahead} />
                </Button>
            </Col>
          </Row>
      </Form>
    );
  }
}

const FiscalCodeInput = ({ fiscalCodeHasError, fiscal_code, onFiscalCodeChange, disabledFields, label }) => {
  return (
    <Form.Item
      required
      label={label}
      validateStatus={fiscalCodeHasError ? 'error' : ''}
      help={
        fiscalCodeHasError ? (
          <FormattedMessage {...messages.fiscalCodeError} />
        ) : (
          ''
        )
      }
    >
      <Input
        name="fiscal_code"
        id="fiscal_code"
        size="large"
        maxLength={16}
        placeholder="Codice fiscale"
        defaultValue={fiscal_code}
        onChange={onFiscalCodeChange}
        disabled={disabledFields}
      />
    </Form.Item>
  );
}

export function mapDispatchToProps(dispatch) {
  return {
    saveProposal: params => dispatch(saveProposal(params)),
    selectContractualCategoryType: contractualCategoryType => dispatch(selectContractualCategoryType(contractualCategoryType)),
  };
}

const mapStateToProps = createStructuredSelector({
  loading: makeSelectLoading(),
  fees: makeSelectFeesSelector(),
  contractualCategoryTypeSelected: makeSelectContractualCategoryTypeSelected(),
  hasErrors: selectHasErrors(),
  proposalErrors: selectErrors(),
});

const withReducer = injectReducer({ key: 'quote', reducer });
const withSaga = injectSaga({ key: 'quote', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(CustomerForm);
